import React, { useEffect } from 'react'
import { Table, message, Tag, Switch } from 'antd'
import { threeInspectionFatigueDrivingModel } from '../fatigueDrivingModel'
import { fatigueDrivingService } from '../fatigueDrivingService'
import { globalPrompt } from '@/components/message'

export function DataTable() {
    const { dataSource, pgCfg, loading, loadData } = threeInspectionFatigueDrivingModel()

    useEffect(() => {
        loadData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const driverDidItPassColor = (status) => {
        return status === 1 ? '#cd201f' : status === 0 ? '#87d068' : '#818387'
    }

    const driverDidItPassText = (status) => {
        return status === 1 ? '不通过' : status === 0 ? '通过' : '未检测'
    }

    const columns: any = [
        {
            title: '序号',
            width: 50,
            align: 'center',
            render: (t: any, r: any, i: number) => i + 1,
        },
        {
            title: '车辆牌照',
            align: 'center',
            width: 200,
            dataIndex: 'vehicleNumber',
        },
        {
            title: '挂车牌照',
            align: 'center',
            width: 200,
            dataIndex: 'trailerNumber',
        },
        {
            title: '司机',
            align: 'center',
            width: 200,
            dataIndex: 'driverName',
        },
        {
            title: '司机检测次数',
            align: 'center',
            width: 150,
            dataIndex: 'driverNum',
        },
        // {
        //     title: '司机检测状态',
        //     width: 160,
        //     align: "center",
        //     dataIndex: 'driverDidItPass',
        //     render: (text, record, index) =>{record.driverNum>0&&<Tag color={driverDidItPassColor(text)}>{driverDidItPassText(text)}</Tag>}
        // },
        {
            title: '发车时间',
            align: 'center',
            width: 170,
            dataIndex: 'departureTime',
        },
        {
            title: '押运员',
            align: 'center',
            width: 150,
            dataIndex: 'escortName',
        },
        {
            title: '押运员检测次数',
            align: 'center',
            width: 200,
            dataIndex: 'escortNum',
        },
        //  {
        //     title: '押运员检测状态',
        //     width: 160,
        //     align: "center",
        //     dataIndex: 'escortDriverDidItPass',
        //     render: (text, record, index) => {record.escortNum>0&&<Tag color={driverDidItPassColor(text)}>{driverDidItPassText(text)}</Tag>}
        // },
        //     {
        //       title: '司机已审核',
        //       align: "center",
        //       // width:150,
        //       dataIndex: 'openThrough',
        //       render: (text, record, index) =>(record.driverDidItPass==1&&record.driverNum==2)?
        //       <Switch
        //       disabled={text=='YES'}
        //       checkedChildren="通过"
        //       unCheckedChildren="不通过"
        //       checked={text=='YES'?true:false}
        //       onChange={() => {openDriver(record.id,)}}/>:
        //       <Switch
        //       disabled
        //       checkedChildren="通过"
        //       unCheckedChildren="不通过"
        //       checked={record.driverDidItPass==0&&record.driverNum==1?true:false}
        //       />
        //   },
        //   {
        //     title: '押运员已审核',
        //     align: "center",
        //     // width:150,
        //     dataIndex: 'escortOpenThrough',
        //     render: (text, record, index) =>(record.escortDriverDidItPass==1&&record.escortNum==2)?
        //     <Switch
        //     disabled={text=='YES'}
        //     checkedChildren="通过"
        //     unCheckedChildren="不通过"
        //     checked={text=='YES'?true:false}
        //     onChange={() => {openEscortDriver(record.id)}}/>:
        //     <Switch
        //     disabled
        //     checkedChildren="通过"
        //     unCheckedChildren="不通过"
        //     checked={record.escortDriverDidItPass==0&&record.escortNum==1?true:false}
        //     />
        // },
        {
            title: '司机已审核',
            align: 'center',
            width: 150,
            dataIndex: 'openThrough',
            render: (text: string, record: { driverDidItPass: number; driverNum: number; id: any; driverName: any }) =>
                record.driverDidItPass === 1 &&
                record.driverNum === 2 && (
                    <Switch
                        disabled={text === 'YES'}
                        checkedChildren="通过"
                        unCheckedChildren="不通过"
                        checked={text === 'YES' ? true : false}
                        onChange={() => {
                            openDriver(record.id, record.driverName)
                        }}
                    />
                ),
        },
        {
            title: '押运员已审核',
            align: 'center',
            width: 150,
            dataIndex: 'escortOpenThrough',
            render: (text: string, record: { escortDriverDidItPass: number; escortNum: number; id: any; escortName: any }) =>
                record.escortDriverDidItPass === 1 &&
                record.escortNum === 2 && (
                    <Switch
                        disabled={text === 'YES'}
                        checkedChildren="通过"
                        unCheckedChildren="不通过"
                        checked={text === 'YES' ? true : false}
                        onChange={() => {
                            openEscortDriver(record.id, record.escortName)
                        }}
                    />
                ),
        },
    ]
    const expandedRowRender = (record) => {
        const fatigueDetectionVosColumns: any = [
            // {
            //   title: '序号',
            //   width: 60,
            //   align: "center",
            //   render: (t, r, i) => i + 1
            // },
            //   {
            //     title: '',
            //     align: "center",
            //     width:250,
            //     dataIndex: '',
            // },
            {
                title: '测试人',
                align: 'center',
                width: 200,
                dataIndex: 'driverName',
            },
            {
                title: '时间',
                align: 'center',
                width: 470,
                dataIndex: 'startTime',
                // render: (t, r, i) => t?t.split(" ")[0]:''
            },
            //  {
            //     title: '结束时间',
            //     width: 160,
            //     align: "center",
            //     dataIndex: 'endTime',
            // },
            {
                title: '时长',
                align: 'center',
                width: 200,
                dataIndex: 'duration',
                render: (t: number) => (t && t <= 91 ? t + '"' : t && t > 91 ? '91"' : ''),
            },
            {
                title: '测试状态',
                align: 'center',
                // width:130,
                dataIndex: 'didItPass',
                render: (text: string) => <Tag color={driverDidItPassColor(text)}>{driverDidItPassText(text)}</Tag>,
            },
        ]
        return (
            <Table
                style={{ marginLeft: '250px' }}
                columns={fatigueDetectionVosColumns}
                dataSource={record.fatigueDetectionVos}
                pagination={false}
                rowKey="id"
                rowClassName={(record) => 'editable-row yh-edit-table-tr background-edeff6'}
                className="custom-expanded-row-table" // 为展开行的Table添加一个自定义类名
            />
        )
    }

    const openDriver = async (id, name) => {
        globalPrompt('modal', {
            title: '开启司机权限',
            type: 'warning',
            text: `确认司机：${name}检测通过后，不可更改!`,
            okText: '确认',
            onOk: async () => {
                let { retData } = await fatigueDrivingService.openDriver(id)
                if (retData) {
                    message.success('开启成功!')
                } else {
                    message.success('开启失败!' + retData)
                }
                loadData()
            },
            cancelText: '取消',
            onCancel: () => {
                return
            },
        })
    }

    const openEscortDriver = async (id, name) => {
        globalPrompt('modal', {
            title: '开启押运员权限',
            type: 'warning',
            text: `确认押运员：${name}检测通过后，不可更改!`,
            okText: '确认',
            onOk: async () => {
                let { retData } = await fatigueDrivingService.openEscortDriver(id)
                if (retData) {
                    message.success('开启成功!')
                } else {
                    message.success('开启失败!' + retData)
                }
                loadData()
            },
            cancelText: '取消',
            onCancel: () => {
                return
            },
        })
    }

    return (
        <Table
            rowKey={(record) => record?.id as string}
            loading={loading}
            columns={columns}
            dataSource={dataSource}
            expandable={{
                expandedRowRender,
                rowExpandable: (record) => record.fatigueDetectionVos && record.fatigueDetectionVos.length > 0,
                // expandIcon: ({ expanded, onExpand, record }) =>
                // expanded ? (
                //   <span style={{color:'#4165E3',cursor: 'pointer'}}  onClick={e => onExpand(record, e)}>收起</span>
                // ) : (
                //   <span style={{color:'#4165E3',cursor: 'pointer'}}  onClick={e => onExpand(record, e)}>展开</span>
                // ) ,
                columnTitle: <span style={{ display: 'flex', justifyContent: 'center' }}>展开</span>,
                columnWidth: 50,
            }}
            pagination={{
                ...pgCfg,
                position: ['bottomRight'],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                },
                showSizeChanger: true,
            }}
            bordered
            tableLayout="fixed"
            scroll={{ x: 'max-content', y: 'calc(100vh - 350px)' }}
            className="custom-table"
        />
    )
}
